export const tradingDetailTableSchema = [
  {
    key: 'entityTypeCd',
    label: '',
    dataType: 'EntityIcon2',
    width: 50,
    prop: 'entityTypeCd',
  },
  {
    key: 'processName',
    label: 'Process',
    dataType: 'Process',
    bold: true,
    'min-width': 230,
    prop: 'processName',
  },
  {
    key: 'processUserMemo',
    label: 'Process User Memo',
    dataType: 'ProcessUserMemo',
    editable: true,
    'min-width': 400,
    width: 480,
    prop: 'processUserMemo',
  },
  {
    key: 'processProgressStatusCd',
    label: 'Status',
    width: 200,
    prop: 'processProgressStatusCd',
  },
  {
    key: 'from',
    label: 'From',
    dataType: 'SelectCustomerSeparatedInfo',
    prop: 'from',
    editable: true,
    type: 'custom',
    options: [],
    'min-width': 350,
  },
  {
    key: 'to',
    label: 'To',
    dataType: 'SelectCustomerSeparatedInfo',
    'min-width': 350,
    prop: 'to',
    editable: true,
    type: 'custom',
    options: [],
  },
  {
    key: 'processUpdateUserName',
    label: 'Updater',
    dataType: 'User',
    prop: 'processUpdateUserName',
    'min-width': 160,
  },
  {
    key: 'processUpdateDate',
    label: 'Update Date',
    dataType: 'SystemDate',
    prop: 'processUpdateDate',
    'min-width': 100,
  },
];
